import { formatPercent } from '@/shared/lib/format';
import { cn } from '@/shared/lib/cn';
import { channelColor } from './financeChartTheme';
import type { ChannelSlice } from './channelSlices';

interface Props {
  slices: ChannelSlice[];
  /** Der gerade hervorgehobene Kanal — kann auch nur überfahren statt festgehalten sein. */
  activeKey: string | null;
  /** Der festgehaltene Kanal; nur er trägt `aria-pressed`. */
  pinnedKey: string | null;
  onPin: (key: string | null) => void;
  onHover: (key: string | null) => void;
}

/**
 * Die Legende ist die eigentliche Bedienfläche des Kanalmix: Zeigen genügt auf einem Touchgerät
 * nicht, also ist jeder Eintrag ein Schalter mit 44 px Höhe.
 */
export function ChannelMixLegend({ slices, activeKey, pinnedKey, onPin, onHover }: Props) {
  return (
    <ul className="flex flex-col justify-center gap-1">
      {slices.map((slice) => {
        const isPinned = pinnedKey === slice.key;
        return (
          <li key={slice.key}>
            <button
              type="button"
              aria-pressed={isPinned}
              onClick={() => onPin(isPinned ? null : slice.key)}
              onMouseEnter={() => onHover(slice.key)}
              onMouseLeave={() => onHover(null)}
              className={cn(
                'hover:bg-card-alt/70 focus-visible:ring-sage flex min-h-11 w-full items-center gap-3 rounded-md px-2 text-left text-sm transition-colors focus-visible:outline-none focus-visible:ring-2',
                activeKey === slice.key && 'bg-card-alt',
              )}
            >
              <span
                aria-hidden
                className="inline-block h-2.5 w-2.5 shrink-0 rounded-full"
                style={{ background: channelColor(slice.key) }}
              />
              <span className="text-ink min-w-0 flex-1 truncate">{slice.name}</span>
              <span className="text-ink-soft shrink-0 tabular-nums">
                {slice.count} {slice.count === 1 ? 'Buchung' : 'Buchungen'}
              </span>
              <span className="text-ink shrink-0 tabular-nums">
                {formatPercent(slice.share * 100)}
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
